export const HiLocale = {
    page: {
        txtTitle: 'UNVOX | तुरंत वोकल्स हटाएं',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox लोगो',
        },
        action: {
            txtBack: 'वापस',
            txtRetry: 'फिर से प्रयास करें',
            txtStartOver: 'दोबारा शुरू करें',
        },
        job: {
            txtCheckingStatus: 'जॉब स्थिति जांची जा रही है',
            txtIdLabel: 'जॉब आईडी',
        },
        footer: {
            linkPrivacyPolicy: 'गोपनीयता नीति',
            linkTerms: 'शर्तें',
            linkRefunds: 'रिफंड',
            linkSupport: 'सहायता',
            txtAllRightsReserved: 'सभी अधिकार सुरक्षित।',
            txtBugReportsAndFeatures: 'बग रिपोर्ट और फीचर अनुरोध',
        },
        share: {
            title: 'UNVOX | एक क्लिक में गाने से वोकल्स हटाएं',
            text: 'अपनी पसंदीदा गानों को आसानी से कराओके के लिए तैयार इंस्ट्रुमेंटल में बदलें!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'एक-क्लिक वोकल रिमूवल',
            txtHeroSubtitle: 'आपकी ट्रैक या सीधे YouTube से तुरंत इंस्ट्रुमेंटल',
            txtInputTypeLabel: 'इनपुट प्रकार',
            txtInputTypeFile: 'ऑडियो फाइल अपलोड करें',
            txtInputTypeYoutube: 'YouTube लिंक',
            txtInputFilePick: 'फाइल चुनें',
            txtInputFileSub: 'सामान्य ऑडियो फॉर्मैट ({{formats}}), अधिकतम {{size}} MB।',
            txtPreviewAction: 'वोकल्स हटाएं',
            txtPreviewFailed: 'अज्ञात त्रुटि हुई। कृपया बाद में फिर प्रयास करें।',
            txtUploadSelectFile: 'अभी तक कोई फाइल नहीं चुनी गई',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'सार्वजनिक YouTube लिंक पेस्ट करें।',
            txtYoutubeMissing: 'कृपया YouTube URL पेस्ट करें।',
            txtYoutubeInvalid: 'मान्य YouTube URL दर्ज करें।',
            txtYoutubeTooLong: 'यह वीडियो 15 मिनट से लंबा है। कृपया छोटा वीडियो चुनें।',
            txtCheckoutUploadFailed: 'अपलोड विफल हुआ। कृपया फिर प्रयास करें।',
            txtUploadMissing: 'अपलोड करने से पहले फाइल चुनें।',
            txtFileTypeInvalid: 'समर्थित नहीं है। कृपया ऑडियो फाइल अपलोड करें (जैसे {{formats}})।',
            txtFileTooLarge: 'फाइल बहुत बड़ी है। अधिकतम आकार {{size}} MB है।',
        },
        previewJob: {
            txtUnavailableTitle: 'प्रीव्यू नहीं बन सका',
            txtUnavailableBody: 'अज्ञात त्रुटि हुई। कृपया बाद में फिर प्रयास करें।',
            txtPreparingTitle: 'प्रीव्यू तैयार किया जा रहा है',
            txtPreparingBody: 'इसमें 2 मिनट तक लग सकते हैं',
        },
        payment: {
            txtUnavailableTitle: 'प्रीव्यू नहीं बन सका',
            txtUnavailableBody: 'अज्ञात त्रुटि हुई। कृपया बाद में फिर प्रयास करें।',
            txtPreparingTitle: 'प्रीव्यू तैयार किया जा रहा है',
            txtCheckoutCancelledBody: 'कोई शुल्क नहीं लिया गया। आप कभी भी फिर प्रयास कर सकते हैं।',
            txtTrackPreviewLabel: 'ट्रैक प्रीव्यू',
            txtTrackPreviewHelper: 'यह प्रीव्यू आपके ट्रैक का 15 सेकंड का क्लिप है',
            txtEmailLabel: 'ईमेल पता',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'डाउनलोड लिंक भेजने के लिए हम इसका उपयोग करेंगे।',
            txtCheckoutAction: 'सिर्फ {{price}} में वोकल्स हटाएं',
            txtCheckoutActionFallback: 'वोकल्स हटाएं',
            txtCheckoutFailed: 'चेकआउट शुरू नहीं हो सका। कृपया फिर प्रयास करें।',
            txtInvalidEmail: 'मान्य ईमेल पता दर्ज करें।',
        },
        processing: {
            txtMissingTitle: 'जॉब आईडी नहीं मिली',
            txtMissingBody: 'इस पेज के लिए जॉब आईडी चाहिए। कृपया नया प्रीव्यू शुरू करें।',
            txtMissingAction: 'अपलोड पर वापस जाएं',
            txtStatusFailed: 'जॉब स्थिति नहीं मिल सकी। कृपया फिर प्रयास करें।',
            txtErrorTitle: 'कुछ गलत हो गया',
            txtSupportAction: 'सहायता से संपर्क करें',
            txtConfirmingTitle: 'भुगतान की पुष्टि हो रही है',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'अपडेट जांचे जा रहे हैं',
            txtWorkingTitle: 'आपकी पूरी ट्रैक प्रोसेस हो रही है',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'एक और शुरू करें',
            txtReadyTitle: 'डाउनलोड तैयार है',
            txtReadyBody: 'आपका इंस्ट्रुमेंटल डाउनलोड के लिए तैयार है।',
            txtDownloadAction: 'डाउनलोड',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'एक और शुरू करें',
        },
        invalidJob: {
            txtTitle: 'अमान्य जॉब आईडी',
            txtBody: 'यह जॉब नहीं मिली। कृपया नया अपलोड शुरू करें।',
            txtAction: 'दोबारा शुरू करें',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'सहायता',
            txtTitle: 'सहायता से संपर्क करें',
            txtLastUpdatedLabel: 'अंतिम अपडेट',
            txtLastUpdatedDate: '9 फ़रवरी 2026',
            txtSectionEmailTitle: 'ईमेल',
            txtSectionEmailBodyPrefix: 'हमें ईमेल करें',
            txtSectionIncludeJobIdTitle: 'अपनी जॉब आईडी शामिल करें',
            txtSectionIncludeJobIdBody: 'कृपया अपनी जॉब आईडी शामिल करें ताकि हम आपकी जॉब जल्दी ढूंढ सकें। यदि आपने भुगतान किया है तो चेकआउट वाला ईमेल भी दें।',
            txtSectionBugReportsTitle: 'बग रिपोर्ट',
            txtSectionBugReportsBody: 'आप फुटर के लिंक से बग रिपोर्ट और फीचर अनुरोध भी भेज सकते हैं।',
        },
        bugReportsFeatures: {
            txtEyebrow: 'फीडबैक',
            txtTitle: 'बग रिपोर्ट और फीचर अनुरोध',
            txtSubtitle: 'UNVOX अभी शुरुआती चरण में है। अगर कुछ गलत लगे या आपके पास कोई आइडिया हो तो भेजें। स्पष्ट रिपोर्ट सबसे तेज़ सुधार लाती हैं।',
            txtWhatToIncludeTitle: 'क्या शामिल करें',
            txtChecklistExpectedVsActual: 'आपने क्या अपेक्षा की थी बनाम क्या हुआ',
            txtChecklistSteps: 'दोहराने के चरण (1, 2, 3)',
            txtChecklistBrowserOs: 'आपका ब्राउज़र और OS',
            txtChecklistJobId: 'जॉब आईडी (यदि इसमें अपलोड शामिल था)',
            txtTipTitle: 'टिप',
            txtTipBody: 'अगर आप ईमेल कर रहे हैं, तो डिलीवरी ईमेल पर सीधे जवाब देकर टेम्पलेट पेस्ट कर सकते हैं।',
            txtTemplateTitle: 'कॉपी-पेस्ट टेम्पलेट',
            txtTemplateBody: 'बग रिपोर्ट / फीचर अनुरोध\n\nप्रकार: bug | feature\nसारांश:\n\nविवरण:\n- क्या हुआ:\n- आपने क्या अपेक्षा की:\n- दोहराने के चरण:\n  1.\n- ब्राउज़र/OS:\n\nवैकल्पिक:\n- जॉब आईडी:\n- YouTube URL:\n- स्क्रीनशॉट/वीडियो:\n',
            txtTemplatePageLabel: 'पेज',
            txtTemplateUserAgentLabel: 'यूज़र एजेंट',
            txtCopyActionIdle: 'टेम्पलेट कॉपी करें',
            txtCopyActionCopied: 'कॉपी हो गया',
            txtCopyActionFailed: 'कॉपी विफल',
            txtCopyHelpFailed: 'क्लिपबोर्ड एक्सेस ब्लॉक हो गया। आप ऊपर का टेक्स्ट चुनकर मैन्युअली कॉपी कर सकते हैं।',
            txtCopyHelpIdle: 'यहां से कुछ भी अपने आप भेजा नहीं जाता। यह पेज सिर्फ रिपोर्ट को अच्छे फॉर्मैट में लिखने में मदद करता है।',
        },
    },
};
